import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";
import VideoModal from "../../commonComponents/modals/VideoModal";

const CarClassicSliderContainer = () => {
  return (
    <>
      <CarBreadcrumb detailImages />
      <CarDetail type="car" classicSlider />
      <VideoModal />
    </>
  );
};

export default CarClassicSliderContainer;
